module.exports = __webpack_public_path__ + "back-end-tools.1pM3owT8.svg";